import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableColumn from "../types/order-optimizer-raily-details-hidden-details-center-tables-driver-table-column";

const getColumns =
  (): OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableColumn[] => {
    const tableColumns: OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableColumn[] =
      [
        {
          header: "",
          title: "",
          accessor: "driverTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "driverHaltingTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "driverDrivingTime",
          colSpan: 3,
        },
        {
          header: "",
          title: "",
          accessor: "driverDistance",
          colSpan: 3,
        },
      ];

    return tableColumns;
  };

const orderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableHelper = {
  getColumns,
};

export default orderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableHelper;
